import React from 'react'
import { useRouter } from 'next/router'
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Button,
  useTheme,
} from '@mui/material'

import ApexChartWrapper from 'src/@core/styles/libs/react-apexcharts'

import DomainIcon from 'mdi-material-ui/Domain'
import BoxCutterOffIcon from 'mdi-material-ui/BoxCutterOff'
import MouseMoveUpIcon from 'mdi-material-ui/MouseMoveUp'
import SlotMachineIcon from 'mdi-material-ui/SlotMachine'
import { WrenchClock, FileCertificateOutline, CurrencyUsd } from 'mdi-material-ui'

import getServerSideProps from 'src/lib/roleBasedAccessControl';

export { getServerSideProps };

const Dashboard = () => {
  const router = useRouter()
  const theme = useTheme()

  const quickAccessButtons = [
    {
      title: 'Firma Ekle',
      description: 'Yeni firma kaydı oluştur',
      icon: <DomainIcon sx={{ fontSize: 40 }} />,
      path: '/company/create',
      color: 'primary',
    },
    {
      title: 'Parça Ekle',
      description: 'Yeni parça kaydı oluştur',
      icon: <BoxCutterOffIcon sx={{ fontSize: 40 }} />,
      path: '/stock/create',
      color: 'secondary',
    },
    {
      title: 'Parça Hareketi',
      description: 'Parça giriş/çıkış işlemi',
      icon: <MouseMoveUpIcon sx={{ fontSize: 40 }} />,
      path: '/stock-move/create',
      color: 'info',
    },
    {
      title: 'Makine Ekle',
      description: 'Yeni makine kaydı oluştur',
      icon: <SlotMachineIcon sx={{ fontSize: 40 }} />,
      path: '/machine/create',
      color: 'warning',
    },
    {
      title: 'Servis Oluştur',
      description: 'Yeni servis kaydı oluştur',
      icon: <WrenchClock sx={{ fontSize: 40 }} />,
      path: '/services/create',
      color: 'error',
    },
    /*{
      title: 'Parça Sertifikası',
      description: 'Parça sertifikası oluştur',
      icon: <FileCertificateOutline sx={{ fontSize: 40 }} />,
      path: '/parca-create/add',
      color: 'success',
    },*/
    {
      title: 'Parça Satışı',
      description: 'Müşterilere parça satışı yap',
      icon: <CurrencyUsd sx={{ fontSize: 40 }} />,
      path: '/stock-move/create',
      color: 'success',
    },
  ]

  return (
    <ApexChartWrapper>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 600 }}>
          Hızlı Erişim Menüsü
        </Typography>
        <Grid container spacing={3}>
          {quickAccessButtons.map((button, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                  },
                }}
                onClick={() => router.push(button.path)}
              >
                <CardContent sx={{ flexGrow: 1, textAlign: 'center', p: 3 }}>
                  <Box
                    sx={{
                      mb: 2,
                      color: `${button.color}.main`,
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    {button.icon}
                  </Box>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                    {button.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {button.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ApexChartWrapper>
  )
}

Dashboard.auth = {
  unauthorized: '/pages/login',
}

export default Dashboard
